import { render, staticRenderFns } from "./rechargeItem.vue?vue&type=template&id=24231567&scoped=true"
import script from "./rechargeItem.vue?vue&type=script&lang=js"
export * from "./rechargeItem.vue?vue&type=script&lang=js"
import style0 from "./rechargeItem.vue?vue&type=style&index=0&id=24231567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24231567",
  null
  
)

export default component.exports